import type { ReactNode } from "react";

/**
 * De kop van een beheeroverzicht: een gekleurd icoon, de titel, en rechts ruimte voor één bediening.
 *
 * <p>De tarief- en productschermen begonnen zonder kop — regelrecht met de tabbladen, of met een kale
 * regel tekst. Op acc staat er een icoon in een licht vlak naast een grote titel, en dat doet meer dan
 * versieren: deze schermen lijken op elkaar (dezelfde tabbladen, dezelfde tabel), en het icoon is waar
 * je aan ziet in welke van de vijf je zit voordat je de titel leest.
 *
 * <p>Eigen component en niet per pagina overgetikt, want dan lopen ze binnen een maand uiteen — precies
 * wat er met deze schermen al gebeurd is.
 */
export function OverviewHeader({
  icon,
  title,
  subtitle,
  right,
}: {
  /** Het icoon van dit scherm; hetzelfde als in het linkermenu, zodat het herkenbaar blijft. */
  icon: ReactNode;
  title: string;
  subtitle?: string;
  /** Bediening die bij de kop hoort — bijvoorbeeld het bereik waarover je kijkt. */
  right?: ReactNode;
}) {
  return (
    <header className="fawkes-overview-header">
      <span className="fawkes-overview-header__icon" aria-hidden="true">
        {icon}
      </span>
      <div className="fawkes-overview-header__text">
        <h1 className="fawkes-overview-header__title">{title}</h1>
        {subtitle ? <p className="fawkes-overview-header__subtitle">{subtitle}</p> : null}
      </div>
      {right ? <div className="fawkes-overview-header__right">{right}</div> : null}
    </header>
  );
}
